import BwicRow from './BwicRow';

export default BwicRow;
